export default __webpack_public_path__ + "static/media/cardspannel.75dc4fd8.svg";